import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import infoHeaderImgQuery from '../queries/infoHeaderImgQuery';

const { createKey } = infoHeaderImgQuery;

const deleteHeaderImg = async ({ infoId }) =>
  request.delete(
    `/Information/${infoId}/image`,
    {},
    'Не удалось удалить шапку информирования',
    'Error'
  );

const useDeleteHeaderImg = () => {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation(deleteHeaderImg, {
    onSuccess: (data, { infoId }) => {
      if (data !== 'Error') {
        queryClient.invalidateQueries(createKey(infoId));
      }
    },
  });

  return {
    deleteHeaderImg: deleteMutation.mutateAsync,
  };
};

export default useDeleteHeaderImg;
